// import React, { forwardRef, useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   Grid,
//   IconButton,
//   InputAdornment,
//   Snackbar,
//   TextField,
//   Modal,
//   Card,
//   MenuItem,
//   Popover,
//   Tooltip,
//   MenuList,
//   Typography,
//   Link,
// } from "@material-ui/core";
// // styles
// import jwt_decode from "jwt-decode";
// import classnames from "classnames";
// import useStyles from "./styles";
// import { CopyToClipboard } from "react-copy-to-clipboard";

// import { useTheme } from "@material-ui/core/styles";
// import axios from "axios";
// import {
//   Keyboard,
//   FileCopy,
//   Launch,
//   FileCopyRounded,
//   FileCopySharp,
//   FileCopyTwoTone,
// } from "@material-ui/icons";
// import useResponsiveSize from "../../utils/useResponsiveSize";
// import { toast } from "material-react-toastify";

// import MaterialTable from "material-table";
// import {
//   AddBox,
//   ArrowUpward,
//   Check,
//   ChevronLeft,
//   ChevronRight,
//   Clear,
//   DeleteOutline,
//   Edit,
//   FilterList,
//   FirstPage,
//   LastPage,
//   Remove,
//   SaveAlt,
//   Search,
//   ViewColumn,
// } from "@material-ui/icons";
// import { useNavigate } from "react-router-dom";
// import Header from "../../components/Header/Header";
// import Sidebar from "../../components/Sidebar/Sidebar";
// import { useLayoutState } from "../../context/LayoutContext";
// import PageTitle from "../../components/Header/PageTitle/PageTitle";
// import JoinMeeting from "./JoinComponent";

// const tableIcons = {
//   Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
//   Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
//   Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
//   Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
//   DetailPanel: forwardRef((props, ref) => (
//     <ChevronRight {...props} ref={ref} />
//   )),
//   Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
//   Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
//   Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
//   FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
//   LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
//   NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
//   PreviousPage: forwardRef((props, ref) => (
//     <ChevronLeft {...props} ref={ref} />
//   )),
//   ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
//   Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
//   SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
//   ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
//   ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
// };
// function makeid(length) {
//   var result = "";
//   var characters =
//     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
//   var charactersLength = characters.length;
//   for (var i = 0; i < length; i++) {
//     result += characters.charAt(Math.floor(Math.random() * charactersLength));
//   }
//   return result;
// }
// export default function MeetingLinkGenerator() {
//   const theme = useTheme();
//   const [meetingId, setMeetingID] = useState("");

//   const token = localStorage.getItem("signinToken");
//   let user;
//   if (token) {
//     var decodedHeader = jwt_decode(localStorage.getItem("signinToken"));
//     user = decodedHeader?.user;
//   }

//   const navigate = useNavigate();
//   var classes = useStyles();
//   var layoutState = useLayoutState();

//   const [fullname, setFullname] = useState("");
//   const [users, setUsers] = useState([]);
//   const [show, setShow] = useState(false);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const getUsers = async () => {
//     const userlist = await axios.get(
//       "https://nowevents.herokuapp.com/user-list"
//     );
//     setUsers(userlist?.data?.user);
//   };

//   useEffect(() => {
//     getUsers();
//   }, []);
//   const padding = useResponsiveSize({
//     xl: 6,
//     lg: 6,
//     md: 6,
//     sm: 4,
//     xs: 1.5,
//   });
//   const style = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: 400,
//     bgcolor: "black",
//     border: "0px solid #000",
//     boxShadow: 24,
//     p: 4,
//     borderRadius: 10,
//   };

//   const add = async () => {
//     if (fullname === "") {
//       toast.error("Full name is required");
//     } else if (email === "") {
//       toast.error("Enter email address");
//     } else if (password === "") {
//       toast.error("Enter your password");
//     } else {
//       axios
//         .post("https://nowevents.herokuapp.com/create", {
//           name: fullname,
//           email: email,
//           password: password,
//         })
//         .then((r) => {
//           if (r?.data?.user === "email is taken") {
//             toast.error("email is taken");
//           } else {
//             toast.success("User added successfully");
//             setShow(!show);
//             getUsers();
//           }
//         });
//     }
//   };
//   const [name, setName] = useState("");
//   const [joinScreenMic, setJoinScreenMic] = useState(true);
//   const [joinScreenWebCam, setJoinScreenWebCam] = useState(true);
//   const [userHasInteracted, setUserHasInteracted] = useState(null);
//   const [selectedMic, setSelectedMic] = useState({ id: null });
//   const [selectedWebcam, setSelectedWebcam] = useState({ id: null });

//   return (
//     <>
//       {" "}
//       <div className={classes.root}>
//         <Header />
//         <Sidebar />
//         <div
//           className={classnames(classes.content, {
//             [classes.contentShift]: layoutState.isSidebarOpened,
//           })}
//         >
//           <div className={classes.fakeToolbar} />
//           <JoinMeeting
//             onClick={async ({ name, webcamOn, micOn, selectedDate, type }) => {
//               setName(name);
//               setJoinScreenMic(micOn);
//               setJoinScreenWebCam(webcamOn);
//               setUserHasInteracted(true);

//               await fetch("https://nowevents.herokuapp.com/get-token", {
//                 method: "GET",
//               })
//                 .then((r) => r.json())
//                 .then(async (response) => {
//                   localStorage.setItem("meetingToken", response?.token);
//                   axios
//                     .post("https://nowevents.herokuapp.com/get-meeting-id", {
//                       token: response?.token,
//                     })
//                     .then(async (r) => {
//                       const streaming = await axios.get(
//                         "https://nowevents.herokuapp.com/live-stream"
//                       );

//                       // if (streaming?.data?.data?.stream_key) {
//                       axios
//                         .post("https://nowevents.herokuapp.com/create-link", {
//                           user: user?._id,
//                           create: selectedDate,
//                           name: name,
//                           token:response?.token,
//                           meetingId: r?.data?.meetingId,
//                           link: `${window.location.href?.replace(
//                             "/meeting/link",
//                             ""
//                           )}/meeting/?id=${r?.data?.meetingId}&stream=${
//                             streaming?.data?.data?.stream_key
//                           }`,
//                         })
//                         .then((sdsd) => {
//                           if (type === "SET") {
//                             setName("")
//                             toast.success("Meeting scheduled successfully");
//                           } else {
//                             window.location.href = `${window.location.href?.replace(
//                               "/meeting/link",
//                               ""
//                             )}/meeting/?id=${r?.data?.meetingId}&stream=${
//                               streaming?.data?.data?.stream_key
//                             }&interacted=${user?.name}`;
//                           }
//                         });
//                         if (type !== "SET") {
//                           setMeetingID(
//                             `${window.location.href?.replace(
//                               "/meeting/link",
//                               ""
//                             )}/meeting/?id=${r?.data?.meetingId}&stream=${
//                               streaming?.data?.data?.stream_key
//                             }`
//                           );
//                         }
                     
//                     });
//                 });
//             }}
//             onCreateMeeting={async () => {
//               // await fetch("https://nowevents.herokuapp.com/get-token", {
//               //   method: "GET",
//               // })
//               //   .then((r) => r.json())
//               //   .then(async (response) => {
//               //     localStorage.setItem("meetingToken", response?.token);
//               //     axios
//               //       .post("https://nowevents.herokuapp.com/get-meeting-id", {
//               //         token: response?.token,
//               //       })
//               //       .then(async (r) => {
//               //         const streaming = await axios.get(
//               //           "https://nowevents.herokuapp.com/live-stream"
//               //         );
//               //         // if (streaming?.data?.data?.stream_key) {
//               //         axios.post(
//               //           "https://nowevents.herokuapp.com/create-link",
//               //           {
//               //             user: user?._id,
//               //             link: `${window.location.href?.replace(
//               //               "/meeting/link",
//               //               ""
//               //             )}/meeting/?id=${r?.data?.meetingId}&stream=${
//               //               streaming?.data?.data?.stream_key
//               //             }`,
//               //           }
//               //         );
//               //         setMeetingID(
//               //           `${window.location.href?.replace(
//               //             "/meeting/link",
//               //             ""
//               //           )}/meeting/?id=${r?.data?.meetingId}&stream=${
//               //             streaming?.data?.data?.stream_key
//               //           }`
//               //         );
//               //       });
//               //   });
//             }}
//             {...{
//               micEnabled: true,
//               webcamEnabled: true,
//             }}
//             name={name}
//             setName={setName}
//             setSelectedMic={setSelectedMic}
//             setSelectedWebcam={setSelectedWebcam}
//             meetingUrl={meetingId}
//             meetingTitle={"Instant Meeting"}
//             participantCanToggleSelfWebcam={"true"}
//             participantCanToggleSelfMic={"true"}
//           />

//           {/* {user?.role === "admin" ? (
//             <JoinMeeting
//               onClick={async ({ name, webcamOn, micOn, selectedDate }) => {
//                 setName(name);
//                 setJoinScreenMic(micOn);
//                 setJoinScreenWebCam(webcamOn);
//                 setUserHasInteracted(true);

//                 await fetch("https://nowevents.herokuapp.com/get-token", {
//                   method: "GET",
//                 })
//                   .then((r) => r.json())
//                   .then(async (response) => {
//                     localStorage.setItem("meetingToken", response?.token);
//                     axios
//                       .post("https://nowevents.herokuapp.com/get-meeting-id", {
//                         token: response?.token,
//                       })
//                       .then(async (r) => {
//                         const streaming = await axios.get(
//                           "https://nowevents.herokuapp.com/live-stream"
//                         );

//                         // if (streaming?.data?.data?.stream_key) {
//                         axios
//                           .post("https://nowevents.herokuapp.com/create-link", {
//                             user: user?._id,
//                             create: selectedDate,
//                             name: name,
//                             meetingId: r?.data?.meetingId,
//                             link: `${window.location.href?.replace(
//                               "/meeting/link",
//                               ""
//                             )}/meeting/?id=${r?.data?.meetingId}&stream=${
//                               streaming?.data?.data?.stream_key
//                             }`,
//                           })
//                           .then((r) => {
//                             window.location.href = `${window.location.href?.replace(
//                               "/meeting/link",
//                               ""
//                             )}/meeting/?id=${r?.data?.meetingId}&stream=${
//                               streaming?.data?.data?.stream_key
//                             }&interacted=${user?.name}`;
//                           });

//                         setMeetingID(
//                           `${window.location.href?.replace(
//                             "/meeting/link",
//                             ""
//                           )}/meeting/?id=${r?.data?.meetingId}&stream=${
//                             streaming?.data?.data?.stream_key
//                           }`
//                         );
//                       });
//                   });
//               }}
//               onCreateMeeting={async () => {
//                 // await fetch("https://nowevents.herokuapp.com/get-token", {
//                 //   method: "GET",
//                 // })
//                 //   .then((r) => r.json())
//                 //   .then(async (response) => {
//                 //     localStorage.setItem("meetingToken", response?.token);
//                 //     axios
//                 //       .post("https://nowevents.herokuapp.com/get-meeting-id", {
//                 //         token: response?.token,
//                 //       })
//                 //       .then(async (r) => {
//                 //         const streaming = await axios.get(
//                 //           "https://nowevents.herokuapp.com/live-stream"
//                 //         );
//                 //         // if (streaming?.data?.data?.stream_key) {
//                 //         axios.post(
//                 //           "https://nowevents.herokuapp.com/create-link",
//                 //           {
//                 //             user: user?._id,
//                 //             link: `${window.location.href?.replace(
//                 //               "/meeting/link",
//                 //               ""
//                 //             )}/meeting/?id=${r?.data?.meetingId}&stream=${
//                 //               streaming?.data?.data?.stream_key
//                 //             }`,
//                 //           }
//                 //         );
//                 //         setMeetingID(
//                 //           `${window.location.href?.replace(
//                 //             "/meeting/link",
//                 //             ""
//                 //           )}/meeting/?id=${r?.data?.meetingId}&stream=${
//                 //             streaming?.data?.data?.stream_key
//                 //           }`
//                 //         );
//                 //       });
//                 //   });
//               }}
//               {...{
//                 micEnabled: true,
//                 webcamEnabled: true,
//               }}
//               name={name}
//               setName={setName}
//               setSelectedMic={setSelectedMic}
//               setSelectedWebcam={setSelectedWebcam}
//               meetingUrl={meetingId}
//               meetingTitle={"Instant Meeting"}
//               participantCanToggleSelfWebcam={"true"}
//               participantCanToggleSelfMic={"true"}
//             />
//           ) : (
//             <JoinMeeting
//               type="participant"
//               onClick={async ({ name, webcamOn, micOn, selectedDate }) => {
//                 axios
//                   .post("https://nowevents.herokuapp.com/get-meeting-link", {
//                     meetingId: name,
//                   })
//                   .then((r) => {
//                     if (r.data?.meeting?.link) {
//                       window.location.href = `${r.data?.meeting?.link}&interacted=${user?.name}`;
//                     } else {
//                       toast.error("Please enter valid meeting id");
//                     }
//                   })
//                   .catch((e) => {
//                     console.log(e);
//                   });
//               }}
//               onCreateMeeting={async () => {}}
//               {...{
//                 micEnabled: true,
//                 webcamEnabled: true,
//               }}
//               name={name}
//               setName={setName}
//               setSelectedMic={setSelectedMic}
//               setSelectedWebcam={setSelectedWebcam}
//               meetingUrl={meetingId}
//               meetingTitle={"Join Meeting"}
//               participantCanToggleSelfWebcam={"true"}
//               participantCanToggleSelfMic={"true"}
//             />
//           )} */}
//         </div>
//       </div>
//     </>
//   );
// }




import React, { forwardRef, useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Snackbar,
  TextField,
  Modal,
  Card,
  MenuItem,
  Popover,
  Tooltip,
  MenuList,
  Typography,
  Link,
} from "@material-ui/core";
// styles
import jwt from "jsonwebtoken";
import * as uuid from "uuid";

import jwt_decode from "jwt-decode";
import classnames from "classnames";
import useStyles from "./styles";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { useTheme } from "@material-ui/core/styles";
import axios from "axios";
import {
  Keyboard,
  FileCopy,
  Launch,
  FileCopyRounded,
  FileCopySharp,
  FileCopyTwoTone,
} from "@material-ui/icons";
import useResponsiveSize from "../../utils/useResponsiveSize";
import { toast } from "material-react-toastify";

import MaterialTable from "material-table";
import {
  AddBox,
  ArrowUpward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import { useLayoutState } from "../../context/LayoutContext";
import PageTitle from "../../components/Header/PageTitle/PageTitle";
import JoinMeeting from "./JoinComponent";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
export default function MeetingLinkGenerator() {
  const theme = useTheme();
  const [meetingId, setMeetingID] = useState("");

  const token = localStorage.getItem("signinToken");
  let user;
  if (token) {
    var decodedHeader = jwt_decode(localStorage.getItem("signinToken"));
    user = decodedHeader?.user;
  }

  const navigate = useNavigate();
  var classes = useStyles();
  var layoutState = useLayoutState();

  const [fullname, setFullname] = useState("");
  const [users, setUsers] = useState([]);
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const getUsers = async () => {
    const userlist = await axios.get(
      "https://nowevents.herokuapp.com/user-list"
    );
    setUsers(userlist?.data?.user);
  };

  useEffect(() => {
    getUsers();
  }, []);
  const padding = useResponsiveSize({
    xl: 6,
    lg: 6,
    md: 6,
    sm: 4,
    xs: 1.5,
  });
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "black",
    border: "0px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
  };

  const add = async () => {
    if (fullname === "") {
      toast.error("Full name is required");
    } else if (email === "") {
      toast.error("Enter email address");
    } else if (password === "") {
      toast.error("Enter your password");
    } else {
      axios
        .post("https://nowevents.herokuapp.com/create", {
          name: fullname,
          email: email,
          password: password,
        })
        .then((r) => {
          if (r?.data?.user === "email is taken") {
            toast.error("email is taken");
          } else {
            toast.success("User added successfully");
            setShow(!show);
            getUsers();
          }
        });
    }
  };
  const [name, setName] = useState("");
  const [joinScreenMic, setJoinScreenMic] = useState(true);
  const [joinScreenWebCam, setJoinScreenWebCam] = useState(true);
  const [userHasInteracted, setUserHasInteracted] = useState(null);
  const [selectedMic, setSelectedMic] = useState({ id: null });
  const [selectedWebcam, setSelectedWebcam] = useState({ id: null });

  return (
    <>
      {" "}
      <div className={classes.root}>
        <Header />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          <JoinMeeting
            onClick={async ({ name, webcamOn, micOn, selectedDate, type }) => {
              setName(name);
              setJoinScreenMic(micOn);
              setJoinScreenWebCam(webcamOn);
              setUserHasInteracted(true);
              const data = await axios.get(
                "https://api.nowvue.live/create100msVideConferencingRoom"
              );

              axios
                .post("https://nowevents.herokuapp.com/create-link", {
                  user: user?._id,
                  create: selectedDate,
                  name: name,
                  token: data?.data?.meetingId,
                  meetingId: data?.data?.meetingId,
                  link: `https://meet-nowevents.vercel.app/preview/${data?.data?.meetingId}/host`,
                })
                .then((sdsd) => {
                  if (type === "SET") {
                    setName("");
                    toast.success("Meeting scheduled successfully");
                  } else {
                    window.location.href = `https://meet-nowevents.vercel.app/preview/${data?.data?.meetingId}/host`;
                  }
                });
              if (type !== "SET") {
                setMeetingID(
                  `https://meet-nowevents.vercel.app/preview/${data?.data?.meetingId}/host`
                );
              }
              //  https://nowvue-meetnow.app.100ms.live/preview/6274fd57bd4f3b56b0774379/producer

              // var app_access_key = "6200b7a76f2b876d58ef1a14";
              // var app_secret =
              //   "kcuDqyrMSg-xU5cFgGJub-p_zR5ooWXQHBmax-fV-GuxrqSFGw6WW5zKL4LZ8NQLUFG_8BB5KLRvddrdzBAconQ12Qs74SLkBHQ-jgiA6DrD2JikwlX75Jk6WWxUsWYo7fz0RLX9IuYWCKI1t-cBv6Eyai8rIb_JrXHvssWEJ9o=";

              // const token = jwt.sign(
              //   {
              //     access_key: app_access_key,
              //     type: "management",
              //     version: 2,
              //     iat: Math.floor(Date.now() / 1000),
              //     nbf: Math.floor(Date.now() / 1000),
              //   },
              //   app_secret,
              //   {
              //     algorithm: "HS256",
              //     expiresIn: "24h",
              //     jwtid: uuid.v4(),
              //   }
              // );
              // axios.post("https://prod-in2.100ms.live/api/v2/rooms", {
              //   name: name,
              //   description:name,
              //   template: "meetnow",
              // },{
              //   headers:{
              //     Authorization:`Bearer ${token}`,
              //     "Content-Type":"application/json"
              //   }
              // }).then(r=>{
              //   console.log(   r.data.id);

              // });

              // axios.post("https://prod-in2.100ms.live/api/v2/rooms", {
              //   name:name,
              //   description: name,
              //   recording_info: {
              //     enabled: true,
              //     upload_info: {
              //       type: "s3",
              //       location: "test-bucket",
              //       prefix: "test-prefix",
              //       options: {
              //         region: "ap-south-1",
              //       },
              //       credentials: {
              //         key: "aws-access-key",
              //         secret: "aws-secret-key",
              //       },
              //     },
              //   },
              // });
              // await fetch("https://nowevents.herokuapp.com/get-token", {
              //   method: "GET",
              // })
              //   .then((r) => r.json())
              //   .then(async (response) => {
              //     localStorage.setItem("meetingToken", response?.token);
              //     axios
              //       .post("https://nowevents.herokuapp.com/get-meeting-id", {
              //         token: response?.token,
              //       })
              //       .then(async (r) => {
              //         const streaming = await axios.get(
              //           "https://nowevents.herokuapp.com/live-stream"
              //         );

              //         // if (streaming?.data?.data?.stream_key) {
              //         axios
              //           .post("https://nowevents.herokuapp.com/create-link", {
              //             user: user?._id,
              //             create: selectedDate,
              //             name: name,
              //             token:response?.token,
              //             meetingId: r?.data?.meetingId,
              //             link: `${window.location.href?.replace(
              //               "/meeting/link",
              //               ""
              //             )}/meeting/?id=${r?.data?.meetingId}&stream=${
              //               streaming?.data?.data?.stream_key
              //             }`,
              //           })
              //           .then((sdsd) => {
              //             if (type === "SET") {
              //               setName("")
              //               toast.success("Meeting scheduled successfully");
              //             } else {
              //               window.location.href = `${window.location.href?.replace(
              //                 "/meeting/link",
              //                 ""
              //               )}/meeting/?id=${r?.data?.meetingId}&stream=${
              //                 streaming?.data?.data?.stream_key
              //               }&interacted=${user?.name}`;
              //             }
              //           });
              //           if (type !== "SET") {
              //             setMeetingID(
              //               `${window.location.href?.replace(
              //                 "/meeting/link",
              //                 ""
              //               )}/meeting/?id=${r?.data?.meetingId}&stream=${
              //                 streaming?.data?.data?.stream_key
              //               }`
              //             );
              //           }

              //       });
              //   });
            }}
            onCreateMeeting={async () => {
              // await fetch("https://nowevents.herokuapp.com/get-token", {
              //   method: "GET",
              // })
              //   .then((r) => r.json())
              //   .then(async (response) => {
              //     localStorage.setItem("meetingToken", response?.token);
              //     axios
              //       .post("https://nowevents.herokuapp.com/get-meeting-id", {
              //         token: response?.token,
              //       })
              //       .then(async (r) => {
              //         const streaming = await axios.get(
              //           "https://nowevents.herokuapp.com/live-stream"
              //         );
              //         // if (streaming?.data?.data?.stream_key) {
              //         axios.post(
              //           "https://nowevents.herokuapp.com/create-link",
              //           {
              //             user: user?._id,
              //             link: `${window.location.href?.replace(
              //               "/meeting/link",
              //               ""
              //             )}/meeting/?id=${r?.data?.meetingId}&stream=${
              //               streaming?.data?.data?.stream_key
              //             }`,
              //           }
              //         );
              //         setMeetingID(
              //           `${window.location.href?.replace(
              //             "/meeting/link",
              //             ""
              //           )}/meeting/?id=${r?.data?.meetingId}&stream=${
              //             streaming?.data?.data?.stream_key
              //           }`
              //         );
              //       });
              //   });
            }}
            {...{
              micEnabled: true,
              webcamEnabled: true,
            }}
            name={name}
            setName={setName}
            setSelectedMic={setSelectedMic}
            setSelectedWebcam={setSelectedWebcam}
            meetingUrl={meetingId}
            meetingTitle={"Instant Meeting"}
            participantCanToggleSelfWebcam={"true"}
            participantCanToggleSelfMic={"true"}
          />

          {/* {user?.role === "admin" ? (
            <JoinMeeting
              onClick={async ({ name, webcamOn, micOn, selectedDate }) => {
                setName(name);
                setJoinScreenMic(micOn);
                setJoinScreenWebCam(webcamOn);
                setUserHasInteracted(true);

                await fetch("https://nowevents.herokuapp.com/get-token", {
                  method: "GET",
                })
                  .then((r) => r.json())
                  .then(async (response) => {
                    localStorage.setItem("meetingToken", response?.token);
                    axios
                      .post("https://nowevents.herokuapp.com/get-meeting-id", {
                        token: response?.token,
                      })
                      .then(async (r) => {
                        const streaming = await axios.get(
                          "https://nowevents.herokuapp.com/live-stream"
                        );

                        // if (streaming?.data?.data?.stream_key) {
                        axios
                          .post("https://nowevents.herokuapp.com/create-link", {
                            user: user?._id,
                            create: selectedDate,
                            name: name,
                            meetingId: r?.data?.meetingId,
                            link: `${window.location.href?.replace(
                              "/meeting/link",
                              ""
                            )}/meeting/?id=${r?.data?.meetingId}&stream=${
                              streaming?.data?.data?.stream_key
                            }`,
                          })
                          .then((r) => {
                            window.location.href = `${window.location.href?.replace(
                              "/meeting/link",
                              ""
                            )}/meeting/?id=${r?.data?.meetingId}&stream=${
                              streaming?.data?.data?.stream_key
                            }&interacted=${user?.name}`;
                          });

                        setMeetingID(
                          `${window.location.href?.replace(
                            "/meeting/link",
                            ""
                          )}/meeting/?id=${r?.data?.meetingId}&stream=${
                            streaming?.data?.data?.stream_key
                          }`
                        );
                      });
                  });
              }}
              onCreateMeeting={async () => {
                // await fetch("https://nowevents.herokuapp.com/get-token", {
                //   method: "GET",
                // })
                //   .then((r) => r.json())
                //   .then(async (response) => {
                //     localStorage.setItem("meetingToken", response?.token);
                //     axios
                //       .post("https://nowevents.herokuapp.com/get-meeting-id", {
                //         token: response?.token,
                //       })
                //       .then(async (r) => {
                //         const streaming = await axios.get(
                //           "https://nowevents.herokuapp.com/live-stream"
                //         );
                //         // if (streaming?.data?.data?.stream_key) {
                //         axios.post(
                //           "https://nowevents.herokuapp.com/create-link",
                //           {
                //             user: user?._id,
                //             link: `${window.location.href?.replace(
                //               "/meeting/link",
                //               ""
                //             )}/meeting/?id=${r?.data?.meetingId}&stream=${
                //               streaming?.data?.data?.stream_key
                //             }`,
                //           }
                //         );
                //         setMeetingID(
                //           `${window.location.href?.replace(
                //             "/meeting/link",
                //             ""
                //           )}/meeting/?id=${r?.data?.meetingId}&stream=${
                //             streaming?.data?.data?.stream_key
                //           }`
                //         );
                //       });
                //   });
              }}
              {...{
                micEnabled: true,
                webcamEnabled: true,
              }}
              name={name}
              setName={setName}
              setSelectedMic={setSelectedMic}
              setSelectedWebcam={setSelectedWebcam}
              meetingUrl={meetingId}
              meetingTitle={"Instant Meeting"}
              participantCanToggleSelfWebcam={"true"}
              participantCanToggleSelfMic={"true"}
            />
          ) : (
            <JoinMeeting
              type="participant"
              onClick={async ({ name, webcamOn, micOn, selectedDate }) => {
                axios
                  .post("https://nowevents.herokuapp.com/get-meeting-link", {
                    meetingId: name,
                  })
                  .then((r) => {
                    if (r.data?.meeting?.link) {
                      window.location.href = `${r.data?.meeting?.link}&interacted=${user?.name}`;
                    } else {
                      toast.error("Please enter valid meeting id");
                    }
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              }}
              onCreateMeeting={async () => {}}
              {...{
                micEnabled: true,
                webcamEnabled: true,
              }}
              name={name}
              setName={setName}
              setSelectedMic={setSelectedMic}
              setSelectedWebcam={setSelectedWebcam}
              meetingUrl={meetingId}
              meetingTitle={"Join Meeting"}
              participantCanToggleSelfWebcam={"true"}
              participantCanToggleSelfMic={"true"}
            />
          )} */}
        </div>
      </div>
    </>
  );
}
